import { useState, useEffect } from 'react';

const STORAGE_KEY = 'civicbeat_onboarding_v1';

interface OnboardingData {
  hasCompletedOnboarding: boolean;
  selectedTopics: string[];
}

const defaultOnboardingData: OnboardingData = {
  hasCompletedOnboarding: true,
  selectedTopics: [],
};

function loadOnboardingData(): OnboardingData {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        ...parsed,
        hasCompletedOnboarding: true,
      };
    }
  } catch (error) {
    console.error('[useOnboarding] Error loading onboarding data:', error);
  }
  return defaultOnboardingData;
}

function saveOnboardingData(data: OnboardingData): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('[useOnboarding] Error saving onboarding data:', error);
  }
}

export function useOnboarding() {
  const [data, setData] = useState<OnboardingData>(loadOnboardingData);

  useEffect(() => {
    saveOnboardingData(data);
  }, [data]);

  const setSelectedTopics = (topics: string[]) => {
    const newData = {
      ...data,
      selectedTopics: topics,
    };
    saveOnboardingData(newData);
    setData(newData);
  };

  const markOnboardingComplete = () => {
    console.log('[useOnboarding] Marking onboarding complete');
    const newData = {
      ...data,
      hasCompletedOnboarding: true,
    };
    console.log('[useOnboarding] New state:', newData);
    saveOnboardingData(newData);
    setData(newData);
  };

  const resetOnboarding = () => {
    setData(defaultOnboardingData);
  };

  return {
    hasCompletedOnboarding: data.hasCompletedOnboarding,
    selectedTopics: data.selectedTopics,
    setSelectedTopics,
    markOnboardingComplete,
    resetOnboarding,
  };
}
